import { render, staticRenderFns } from "./provider-jumbotron.vue?vue&type=template&id=390b70b8&lang=pug&"
import script from "./provider-jumbotron.vue?vue&type=script&lang=js&"
export * from "./provider-jumbotron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/lang/products/broadband.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230928161648%2Fcomponents%2Fproducts%2Fbroadband%2Fprovider-jumbotron.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports